import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "../Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import zenloomerHorizontal from "../../assets/images/zenloomer-horizontal.png";
import zenloomerIcon from "../../assets/images/zenloomer-icon.png";
import SidebarContent from "./SidebarContent";

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box logo-sidebar-box" style={{ background: 'transparent' }}>
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={zenloomerIcon} alt="Zenloomer" height="24" style={{ objectFit: 'contain' }} />
            </span>
            <span className="logo-lg">
              <img src={zenloomerHorizontal} alt="Zenloomer" height="28" style={{ objectFit: 'contain' }} />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={zenloomerIcon} alt="Zenloomer" height="24" style={{ objectFit: 'contain' }} />
            </span>
            <span className="logo-lg">
              <img src={zenloomerHorizontal} alt="Zenloomer" height="28" style={{ objectFit: 'contain' }} />
            </span>
          </Link>
        </div>
        <SidebarContent sidebarType={props.type} />
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStatetoProps, {})(withRouter(withTranslation()(Sidebar)));
